import jwtAuthAxios from "../auth/jwtAuth";

// Turnos de los reportes: los de la empresa (sin local) y los propios de un local, que reemplazan a los de la empresa.
const workShiftServices = {};

workShiftServices.get = async (storeId = null) => {
    const { data } = await jwtAuthAxios.get("/automations/work_shifts", { params: storeId ? { store_id: storeId } : {} });
    return data;
};

workShiftServices.save = async (storeId, shifts) => {
    const { data } = await jwtAuthAxios.put("/automations/work_shifts", { store_id: storeId || undefined, shifts }, { silentErrors: true });
    return data;
};

// El local vuelve a usar los turnos de la empresa.
workShiftServices.useCompanyShifts = async (storeId) => {
    const { data } = await jwtAuthAxios.delete("/automations/work_shifts", { params: { store_id: storeId } });
    return data;
};

export default workShiftServices;
